/**
 * Module-level navigator singleton.
 * Allows any view to trigger navigation without a direct router reference.
 * @module app/navigate
 */

let _navigate: ((routeId: string) => void) | null = null;

/** Called once by main.ts after the router is created. */
export function registerNavigator(fn: (routeId: string) => void): void {
	_navigate = fn;
}

/** Navigate to a route by id (e.g. "fleet/overview"). No-op if router not yet ready. */
export function navigateTo(routeId: string): void {
	_navigate?.(routeId);
}
